import { z } from "zod";

import { addCustomFieldIssues, customFieldsSchema } from "components/BaseForm";

const requiredNumber = message =>
  z.number({ required_error: message, invalid_type_error: message });

/** The Campaign form schema, shared by create and edit. */
export const buildCampaignSchema = ({ customFieldConfigs }) =>
  z
    .object({
      name: z.string().trim().min(1, "A name is required"),
      status: requiredNumber("A status is required"),
      assigned_user_id: requiredNumber("An assignee is required"),
      start_time: z
        .string({ invalid_type_error: "A start time is required" })
        .min(1, "A start time is required"),
      end_time: z.string().nullable(),
      form_id: z.number().nullable(),
      limit_email_templates: z.boolean(),
      email_templates: z.array(z.number()),
      email_service: requiredNumber("An email service is required"),
      email_type: z.string().min(1, "An email type is required"),
      region_id: z.number().nullable(),
      case_campaign_status_preset: z.number().nullable(),
      campaign_status_preset: z.number().nullable(),
      revenue_status_preset: z.number().nullable(),
      revenue_recipient_preset: z.number().nullable(),
      description: z.string().trim().min(1, "A description is required"),
      custom_fields: customFieldsSchema,
    })
    .superRefine((values, ctx) => {
      if (
        values.start_time &&
        values.end_time &&
        values.end_time <= values.start_time
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["end_time"],
          message: "End time must be after the start time",
        });
      }
      addCustomFieldIssues(customFieldConfigs, values.custom_fields, ctx);
    });
